<a (click)="linkClick(blogData?.Url)" role="button" class="each-policy position-relative d-block">
    <div class="img-wrapper" *ngIf="blogData?.Image">
        <img [src]="imageUrl+blogData.Image" alt="Blog Category Item Image">
    </div>
    <h4 class="heading sec-heading3" *ngIf="blogData?.Title">{{blogData.Title}}</h4>
</a>